// extracted by mini-css-extract-plugin
module.exports = {"no-scroll":"index__no-scroll__2J17m"};